import React from 'react';

import { LeadModel } from '@/typings/models/Lead';
import EditableTextField from '@/components/Lead/EditableTextField';
import PhoneNumberFormat from '@/components/format/PhoneNumberFormat';

import styles from './index.less';
import classNames from 'classnames';

const getLeadPhone = (lead: LeadModel) => lead?.customer?.phone;

const LeadPhone = ({
  lead,
  readonly,
  isTable,
}: {
  lead: LeadModel;
  readonly: boolean;
  isTable: boolean;
  showOnePhone?: boolean;
}) => {
  const phone = getLeadPhone(lead);

  return (
    <EditableTextField
      className={classNames(styles.leadPhone, {
        [styles.leadPhoneTable]: isTable,
      })}
      isTable={isTable}
      editable={!readonly}
      lead={lead}
      property={'customer.phone'}
    >
      <PhoneNumberFormat phoneNumber={phone} variant="link" />
    </EditableTextField>
  );
};

export default LeadPhone;
